const host = "";//"https://trr.azurewebsites.net";
export class Service {
    static getCalendarEvents(month, year, sites) {
        return Service.__post(host + '/api/Calendar/GetMonthEvents', { month, year, sites })
    }
    static getChaptersForSelector() {
        return Service.__get(host + '/api/Chapter/GetGrouppedChapters')
    }

    //Global Services
    static getServiceById(id) {
        return Service.__get(host + '/api/Service/GetById/' + id)
    }
    static saveService(data) {
        return Service.__post(host + '/api/Service/Save', data)
    }
    static deleteService(data) {
        return Service.__post(host + '/api/Service/Delete', data)
    }
    static getServiceList() {
        return Service.__post(host + '/api/Service/GetServices')
    }
    static getGroupedServices() {
        return Service.__post(host + '/api/Service/GetGroupedServices')
    }
    static getFilteredServiceList(filter) {
        return Service.__post(host + '/api/Service/GetFilteredServices', filter)
    }
    static getServiceGroups() {
        return Service.__get(host + '/api/Lists/GetServiceGroups')
    }

    static contactAdmin(info) {
        return Service.__post(host + '/api/Account/ContactAdmin', info);
    }



    //Chapters
    static getChapterById(id) {
        return Service.__get(host + '/api/Chapter/GetById/'+id)
    }
    static saveChapter(data) {
        return Service.__post(host + '/api/Chapter/Save', data)
    }
    static deleteChapter(data) {
        return Service.__post(host + '/api/Chapter/Delete', data)
    }


    static getAllRegeions() {
        //TODO: remap
        return Service.__get('/Regions.json');
    }
    static getChapterMembers(id) {
        //TODO: delete
        return Service.__get('/Members.json');
    }

    //Global Events

    static getEventTypes() {
        return Service.__get(host + '/api/Lists/getEventTypes')
    }
    static getEventTypesActiveOnly() {
        return Service.__get(host + '/api/Lists/getEventTypesActiveOnly')
    }
    static getEventsList(filter) {
        filter = filter || { from: '2019-03-01', to: '2019-04-01' };
        return Service.__post(host + '/api/Calendar/GetFilteredList', filter)
    }
    static changeEvent(event) {
        return Service.__post(host + '/api/Event/ChangeEvent', event)
    }
    static getEvent(id) {
        return Service.__get(host + '/api/Event/GetEventById/' + id)
    }
    static getEventAttendees(id) {
        return Service.__get(host + '/api/Event/GetEventAttendees/' + id)
    }
    static addEventAttendees(attendees) {
        return Service.__post(host + '/api/Event/AddEventAttendees', attendees);
    }
    static removeEventAttendee(id, attendee) {
        return Service.__post(host + '/api/Event/RemoveEventAttendees/' + id, attendee)
    }
    static getSiteMembers(id) {
        return Service.__get(host + '/api/Event/GetSiteMembers/' + id)
    }
    static getEventSelectedServices(eventId) {
        return Service.__get(host + '/api/Event/GetEventSelectedServices/' + eventId)
    }
    static deleteEventService(eventServiceLineId) {
        return Service.__post(host + '/api/Event/DeleteEventService/' + eventServiceLineId);
    }
    static addEventService(id, line) {
        return Service.__post(host + '/api/Event/AddEventService/' + id, line);
    }
    static addEventServices(services) {
        return Service.__post(host + '/api/Event/AddEventServices/', services);
    }
    static updateEventService(id, line) {
        return Service.__post(host + '/api/Event/UpdateEventService/' + id, line);
    }
    static getEventPictures(id) {
        return Service.__get(host + '/api/Event/GetEventPhotos/' + id);//Service.__get('/Pictures.json');//
    }
    static getEventTypeById(id) {
        return Service.__get(host + '/api/Event/GetEventTypeById/' + id)
    }
    static saveEventType(data) {
        return Service.__post(host + '/api/Event/SaveEventType', data)
    }


    //Profile
    static getProfile() {
        return Service.__get(host + '/api/Profile/Get');
    }
    static getProfileById(id) {
        return Service.__get(host + '/api/Profile/GetById/'+id);
    }
    static deleteProfile(info) {
        return Service.__post(host + '/api/Profile/Delete', info);
    }
    static setProfile(info) {
        return Service.__post(host + '/api/Profile/Set',info);
    }
    static getFilteredMembers(filter) {
        return Service.__post(host + '/api/Profile/GetFiltered', filter);
    }
    static SendEmailConfirmation(id) {
        return Service.__get(host + '/api/Account/RequestEmailConfirmationToken/' + id);
    }

    //Payment
    static GetPaymentUserData(orderId) {
        return Service.__post(host + '/api/Pay/GetUserData', orderId);
    }
    static GetPaymentInfo(orderId) {
        return Service.__post(host + '/api/Pay/GetPaymentInfo', orderId);
    }
    static RefundPayment(orderId) {
        return Service.__post(host + '/api/Pay/RefundPayment', orderId);
    }

    //User event
    static getMemberEvent(id) {
        return Service.__get(host + '/api/MemberEvent/GetEventById/' + id)
    }
    static getMemberEventByUserEventId(userEventId) {
        return Service.__get(host + '/api/MemberEvent/GetEventByUserEventId/' + userEventId)
    }
    static changeMemberEvent(event) {
        return Service.__post(host + '/api/MemberEvent/ChangeEvent', event)
    }
    static getMemberEventOrders(id) {
        return Service.__post(host + '/api/MemberEvent/GetEventOrders/' + id)
    }
    static getMemberOrders(id) {
        return Service.__post(host + '/api/MemberEvent/GetOrders/' + id)
    }
    static getMemberEventOrderById(id) {
        return Service.__post(host + '/api/MemberEvent/GetEventOrderById/' + id)
    }
    static updateOrderServiceSpecialPrice(orderLineModel) {
        return Service.__post(host + '/api/MemberEvent/UpdateOrderLineSpecialPrice/', orderLineModel)
    }
    static addOrderService(lines) {
        return Service.__post(host + '/api/MemberEvent/AddMemberEventOrderServiceLine/', lines);
    }
    static deleteOrderService(line) {
        return Service.__post(host + '/api/MemberEvent/DeleteMemberEventOrderServiceLine/', line);
    }
    static deleteEventOrder = (userEventOrderId) => {
        return Service.__post(host + '/api/MemberEvent/DeleteMemberEventOrder/' + userEventOrderId);
    }


    

    //Reports
    static getPaymentReport(filter) {
        return Service.__post(host + '/api/Reports/PaymentReport', filter);
    }

    static getMembersReport() {
        return Service.__get(host + '/api/Reports/Members');
    }

    static getEventsByTypeReport(range) {
        return Service.__post(host + '/api/Reports/EventsByType', range);
    }
    static getVeteransByEventTypeReport(range) {
        return Service.__post(host + '/api/Reports/VeteransByEventType', range);
    }
    static getVeteransBySiteReport(range) {
        return Service.__post(host + '/api/Reports/VeteransBySite', range);
    }

    static getVeteransAttendence(range) {
        return Service.__post(host + '/api/Reports/VeteransAttandance', range);
    }


    static selfSignUp(id, date) {
        return Service.__get(host + '/api/Event/Attend/' + { id, date });
    }
    static selfSignOff(id, date) {
        return Service.__get(host + '/api/Event/UnAttend/' + { id, date });
    }

    static getOptionList() {
        return Service.__get(host + '/api/Profile/GetAllOptions');
    }
    static getUserOptions(id) {
        return Service.__get(host + '/api/Profile/getUserOptions/'+id);
    }
    static addUserOption(id, opt) {
        return Service.__post(host + '/api/Profile/addUserOption/' + id, opt);
    }
    static deleteUserOption(id, opt) {
        return Service.__post(host + '/api/Profile/deleteUserOption/' + id, opt);
    }
    static editUserOption(id, opt) {
        return Service.__post(host + '/api/Profile/editUserOption/' + id, opt);
    }

    static getBCCInfoLists() {
        return Service.__get(host + '/api/Profile/BCCInfoLists');
    }

    static throwBlob(blob, fileName) {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName ? fileName : 'sample.xlsx');
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
    }

    static download(url) {
        return fetch(host + url).then(resp => resp.blob());
    }

    static downloadWithPost(url, data) {
        return fetch(host + url, {
            method: 'post',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(resp => resp.blob());
    }

    static __get(url) {
        return fetch(url).then(response  => {
            if (response.ok) {
                const contentType = response.headers.get('Content-Type') || '';
                if (contentType.includes('application/json')) {
                    return response.json().catch(error => {
                        return Promise.reject(new Error('Invalid JSON: ' + error.message));
                    });
                }
                return Promise.reject(new Error('Invalid content type: ' + contentType));
            } else {
                if (response.status == 404) {
                    return Promise.reject(new Error('Page not found: ' + url));
                }
                return response.json().then(err => {
                    return Promise.reject(err);
                });
            }
        }).catch(error => {
            console.log(error);
            return Promise.reject(new Error(error.message));
        });
    }
    
    static __post(url, data) {
        //var promice = fetch(url, {
        //    method: 'post',
        //    body: JSON.stringify(data),
        //    headers: {
        //        'Content-Type': 'application/json'
        //    }
        //});
        //promice.catch(err => console.error(err));
        //return promice.then(data => {
        //    return data.json();
        //}).catch(err => console.error(err));


        return fetch(url, {
            method: 'post',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => {
            if (response.ok) {
                const contentType = response.headers.get('Content-Type') || '';
                if (contentType.includes('application/json')) {
                    return response.json().catch (error => {
                        return Promise.reject(new Error('Invalid JSON: ' + error.message));
                    });
                }
                return Promise.reject(new Error('Invalid content type: ' + contentType));
            } else {
                if (response.status == 404) {
                    return Promise.reject(new Error('Page not found: ' + url));
                }
                return response.json().then(err => {
                    return Promise.reject(err);
                });
            }
        }).catch(error => {
            console.log(error);
            return Promise.reject(new Error(error.message));
        });
    }
    static uploadPictures(eventId, input) {
        let formData = new FormData();
        for (var i = 0; i < input.files.length; i++) {
            formData.append('files', input.files[i], input.files[i].name);
        }
        var promice = fetch(host + '/api/Event/UploadFile/' + eventId, { body: formData, method: 'post' });
        promice.catch(err => console.error(err));
        return promice.then(data => {
            return data.json();
        }).catch(err => console.error(err));
    }


    static uploadTaxExempt(userId, input) {
        let formData = new FormData();
        for (var i = 0; i < input.files.length; i++) {
            formData.append('files', input.files[i], input.files[i].name);
        }
        var promise = fetch(host + '/api/Profile/UploadTaxExemptCertificate/' + userId, { body: formData, method: 'post' });
        promise.catch(err => console.error(err));
        return promise
            .then(response => {
                if (response.ok) {
                    const contentType = response.headers.get('Content-Type') || '';
                    if (contentType.includes('text/plain')) {
                        return response.text().catch(error => {
                            return Promise.reject(new Error('Invalid text: ' + error.message));
                        });
                    }
                    else if (contentType.includes('application/json')) {
                        return response.json().catch(error => {
                            return Promise.reject(new Error('Invalid JSON: ' + error.message));
                        });
                    }
                    return Promise.reject(new Error('Invalid content type: ' + contentType));
                } else {
                    if (response.status == 404) {
                        return Promise.reject(new Error('Page not found'));
                    }
                    return response.json().then(err => {
                        return Promise.reject(err);
                    });
                }
            })
            .catch(err => console.error(err));
    }
}


// WEBPACK FOOTER //
// ./src/components/ApiService.jsx